import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Asset, ImageView, LottieAnimation, AssetType } from "@thenounproject/lingo-core";
import PlayButtonOverlay from "@components/kits/PlayButtonOverlay";

const ClickableWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  pointer-events: auto;
`;

type Props = {
  asset: Asset;
  thumbnailSize: number;
  autoplay?: boolean;
};

const AnimatedThumbnail: React.FC<Props> = ({ asset, thumbnailSize, autoplay }) => {
  const [isPlaying, setIsPlaying] = useState(autoplay);
  const isLottie = asset.type === AssetType.lottie;

  useEffect(() => {
    setIsPlaying(autoplay);
  }, [autoplay]);

  const handlePlayClick = () => {
    setIsPlaying(true);
  };

  const handlePauseClick = () => {
    if (!autoplay) {
      setIsPlaying(false);
    }
  };

  if (isPlaying) {
    if (isLottie) {
      return (
        <>
          {/* Kind of a hack but this hidden image view helps size the contianer correctly */}
          <ImageView
            width="100%"
            height="100%"
            src={asset.thumbnails[thumbnailSize]}
            style={{ visibility: "hidden" }}
          />
          <ClickableWrapper onClick={handlePauseClick}>
            <LottieAnimation permalink={asset.permalink} />
          </ClickableWrapper>
        </>
      );
    }
    // GIF - use permalink for animated version
    return (
      <>
        <ImageView width="100%" height="100%" src={asset.permalink} />
        <ClickableWrapper onClick={handlePauseClick} />
      </>
    );
  }

  return (
    <>
      <ImageView width="100%" height="100%" src={asset.thumbnails[thumbnailSize]} />
      <ClickableWrapper onClick={handlePlayClick}>
        <PlayButtonOverlay iconSize={60} />
      </ClickableWrapper>
    </>
  );
};

export default AnimatedThumbnail;
